<div class="d-flex flex-wrap">
  <div class="input-group">
    <div class="dp-hidden position-absolute">
      <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker" [autoClose]="'outside'"
        (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden"
        [startDate]="fromDate!" tabindex="-1">
      <ng-template #t let-date let-focused="focused">
        <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
      </ng-template>
    </div>
  </div>
  <div class="d-flex me-2 position-relative">      
    <input #dpFromDate class="form-control w-auto" placeholder="dd.mm.yyyy" name="dpFromDate"
      [value]="format(fromDate)" (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
    <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button"><i
        class="bi bi-calendar"></i></button>
  </div>
  <div class="d-flex position-relative">
    <input #dpToDate class="form-control w-auto" placeholder="dd.mm.yyyy" name="dpToDate"
      [value]="format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value)">
    <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button"><i
        class="bi bi-calendar"></i></button>
  </div>
</div>
